var map = {
	"./en": 370,
	"./it": 371
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;



//////////////////
// WEBPACK FOOTER
// ./src/app/locales nonrecursive ^\.\/[^\.]*$
// module id = 675
// module chunks = 0